// extracted by mini-css-extract-plugin
module.exports = {"menu":"user-menu-module__menu___3GuR2","special":"user-menu-module__special___2mSWM"};